import { type AxiosResponse, AxiosError } from 'axios'
import type { Api } from '@axilon-apps/libs-shared-types'

import getters from '../utils/error-response-getters'

class ApiResponse<T, E> {
  private response!: AxiosResponse<T>
  private errorResponse!: AxiosError<E>

  constructor(response: AxiosResponse<T> | AxiosError<E>) {
    if (response instanceof AxiosError) {
      Object.defineProperty(this, 'errorResponse', {
        configurable: false,
        enumerable: false,
        value: response,
        writable: false
      })
    } else {
      this.response = response
    }
  }

  public isSuccess() {
    return !this.errorResponse
  }

  public isFailure() {
    return Boolean(this.errorResponse)
  }

  public data() {
    return this.response.data
  }

  public errorCause() {
    return this.errorResponse?.cause
  }

  public toJSON() {
    if (!this.errorResponse) {
      return { status: this.response?.status }
    }

    return {
      name: this.errorResponse.name,
      message: this.errorResponse.message,
      code: this.errorResponse.code,
      status: this.errorResponse.status ?? this.errorResponse.response?.status,
      url: this.errorResponse.config?.url
    }
  }

  public isInternalServerError() {
    return this.errorResponse?.code === AxiosError.ERR_NETWORK
  }

  public error(): Api.Error.Response {
    return {
      message: getters.message(this.errorResponse.response),
      reason: getters.reason(this.errorResponse.response),
      status: getters.status(this.errorResponse.response),
      fields: getters.fields(this.errorResponse.response)
    }
  }
}

export default ApiResponse
